// `size` sits 4th so it lands inline ahead of the "More" pill at the breakpoints that show pills —
// card dimensions are a primary buying decision on print categories.
export const FACET_ORDER = ['style', 'color', 'price', 'size', 'photo', 'foil', 'orientation', 'format'] as const;
